import { FC } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { appRoutes } from 'constants/routes';
import { NavLinkProps } from 'interfaces';

import { TooltipWrap } from 'components/ui/TooltipWrap';

import styles from './SidebarTab.module.scss';

interface SidebarTabProps extends NavLinkProps {
  isActive: boolean;
}

export const SidebarTab: FC<SidebarTabProps> = ({
  title,
  link,
  passiveIcon,
  activeIcon,
  isActive,
}) => (
  <TooltipWrap title={title} placement="bottom-start">
    <Link
      to={isActive ? appRoutes.MAP : link}
      className={cn(
        'w-8 h-8 [&>*]:w-full [&>*]:h-full',
        isActive ? '!text-bright_product' : '!text-tpg_base',
        styles.inactiveHovers
      )}
    >
      {isActive ? activeIcon : passiveIcon}
    </Link>
  </TooltipWrap>
);
